<template>
    <div class="page_box">
        <div class="login_box">
            <div class="login_left">
<!--                <img src="../assets/image/left.png" alt="">-->
            </div>
            <div class="login_right">
                <div class="login_header">
                    <el-button type="text">
                        <a href="http://techsupport.megvii.com/">返回</a>
                    </el-button>
                    <div>
                        <img src="../assets/image/megvii.png" alt="旷视科技" style="height:30px">
                    </div>
                </div>
                <div class="login_bottom">
                    <div style="display: none">
                         <span style="display:inline-block;font-size:50px;color:#9e9e9ebf">
                                <i class="el-icon-s-custom" ></i>
                            </span>
                    </div>
                    <el-form :model="loginForm" status-icon  ref="loginForm" class="login_form">
                        <el-form-item prop="emailName">
                            <el-input placeholder="请输入邮箱" autocomplete name="emailName" v-model="loginForm.emailName" @keyup.enter.native="submitForm('loginForm')">
                                <template slot="prepend"><i class="el-icon-user"></i></template>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="passWord">
                            <el-input type="passWord" placeholder="请输入密码" v-model="loginForm.passWord"  @keyup.enter.native="submitForm('loginForm')">
                                <template slot="prepend"><i class="el-icon-unlock"></i></template>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button :disabled="!loginForm.emailName || !loginForm.passWord" type="primary" round @click="submitForm('loginForm')" class="login_btn">登  录</el-button>
                            <div class="login_tip">
                                <el-button type="text" @click="go('register')">注册账号</el-button>
                                <el-button type="text" @click="go('pas')">重置密码</el-button>
                            </div>
                            <p class="text_center">如无账户，请先进行注册，以便提交和追踪问题</p>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {login} from "../request/api";
    export default {
        name: "login",
        data(){
            var validateEmail =(rule, value, callback)=>{
                if(value){
                    let flag=/^[a-zA-Z0-9_.@&-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(value)
                    if(flag){
                        callback()
                    }else{
                        callback(new Error('邮箱格式不正确'))
                    }
                }else{
                    callback(new Error('输入邮箱'))
                }
            }
            return {
                loginFlag:true,
                loginForm:{
                    emailName:'',
                    passWord:''
                },
                loginRules: {
                    emailName: [
                        { validator: validateEmail,required:true, trigger: 'blur' },
                    ],
                    passWord: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                    ]
                }
            }
        },
        methods:{
            toTree(data,list) {
                let result = []
                if (!Array.isArray(data)) {
                    return result
                }
                if (!data.length) {
                    return result;
                }
                let map = {};
                data.forEach(item=>{
                    item.items=[]
                    if(list.length){
                        list.forEach(item2=>{
                            if(item2.classify==item.id){
                                item.items.push(item2)
                                data.forEach(item3=>{
                                    if(item3.id==item.parentId){
                                        (item3['items'] || (item3['items'] = [])).push(item2);
                                        
                                    }
                                    if(item3.items && item3.items.length){
                                        item3['items'].sort((a,b)=>{
                                           return b.createdAt - a.createdAt
                                       })
                                    }
                                })
                            }
                        })
                    }
                    if(item.items.length){
                       item.items.sort((a,b)=>{
                           return b.createdAt - a.createdAt
                       })
                   }
                    map[item.id] = item;
                    let parent = map[item.parentId];
                    if (parent) {
                        (parent.children || (parent.children = [])).push(item);
                        if(parent.children.length){
                            parent.children.sort((a,b)=> {
                                return a.categoryOrder - b.categoryOrder
                            })
                        }
                    } else {
                        result.push(item);
                    }
                })
                let out=[]
                let obj={}
                obj.id=0
                obj.catalogName='全部'
                obj.categoryOrder=1
                obj.children=result
                obj.items=list
                out.push(obj)
                // return result;
                return out 
            },
            go(name){
                this.$router.push(`/${name}`)
            },
            submitForm(formName){
                if(!(this.loginForm.emailName.trim())){
                    this.$message.warning('请输入邮箱')
                    return false
                }
                if(!(this.loginForm.passWord.trim())){
                    this.$message.warning('请输入密码')
                    return false
                }
                    let flag=/^[a-zA-Z0-9_.@&-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.loginForm.emailName)
                    if(flag){
                        let data={
                            emailName:this.loginForm.emailName,
                            passWord:this.loginForm.passWord
                        }
                        login(data).then(res=>{
                            if(res.data.status==0){
                                sessionStorage.setItem('id',res.data.accountId)
                                sessionStorage.setItem('name',res.data.accountName)
                                sessionStorage.setItem('sess',res.data.session)
                                sessionStorage.setItem('email',this.loginForm.emailName)
                                let obj={
                                    id:res.data.accountId,
                                    name:res.data.accountName,
                                    email:this.loginForm.emailName
                                }
                                this.$store.commit('set_user',obj)
                                this.$router.push( '/home' );
                            }else{
                                this.$message.error(res.data.msg)
                            }
                        })
                    }else{
                        this.$message.warning('请输入正确的邮箱格式')
                    }
                // this.$refs[formName].validate((valid) => {
                //     if (valid) {
                //         let data={
                //             emailName:this.loginForm.emailName,
                //             passWord:this.loginForm.passWord
                //         }
                //         login(data).then(res=>{
                //             if(res.data.status==0){
                //                 this.$router.push( '/home' );
                //                 this.$store.commit('set_id', res.data.accountId);
                //             }else{
                //                 this.$message.error(res.data.msg)
                //             }
                //         })
                //     }else{
                //         return false;
                //     }
                // });
            }
        }
    }
</script>

<style>
    .page_box{
        display: flex;
        justify-content: center;
        align-items: center;
        height:100%;
        /*background-color:#0a36d7;*/
        /*background-image: linear-gradient(34deg, #0d31e1, #78b1ebad,#2196f3);*/
        background-image: radial-gradient(#4fc3f7d9, #0a36d7);
    }
    .login_box{
        display: flex;
        width:980px;
        height:560px;
        border-radius: 20px;
        overflow: hidden;
    }
    .login_left{
        width:50%;
        /*flex:1;*/
        /*min-width:400px;*/
        /*background:#42b983;*/
        background:url('../assets/image/left.png') no-repeat center top;
        background-size:cover;
    }
    .login_right{
        width:50%;
        /*flex:2;*/
        padding:30px 40px;
        background:#fff;
        box-sizing: border-box;
    }
    .login_header{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .login_bottom{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height:95%;
    }
    .login_form{
        width:350px;
        margin-top:50px;
    }
    .login_form .el-input-group__prepend{
        background-color:transparent;
    }
    .login_form .el-input-group__prepend,.login_form .el-input__inner{
        border:none;
    }
    .login_form  .el-input__inner{
        border-radius:0 10px 10px 0;
        padding:0 15px 0 0 ;
    }
    .login_form .el-form-item__content .el-input-group{
        border:1px solid #9e9e9e6b;
        border-radius:10px;
    }
    .login_box .submit_button{
        background-color:#3a8ee6;
    }
    .login_box .el-form .el-button{
        width:100%;
    }
    .login_box .el-form .el-button.is-round{
        padding:15px 23px;
    }
    .w400{
        width:400px;
    }
    .login_btn{
        font-size:16px;
        margin:20px 0 30px;
    }
    .login_tip{
        display: flex;
    }
    .login_tip .el-button{
        padding:0 20px;
    }
    .text_center{
        text-align:center;
    }
    input:-internal-autofill-previewed, input:-internal-autofill-selected {
        transition: background-color 5000s ease-in-out 0s !important;
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active,
    .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover{
        opacity: 0.6;
    }
    .el-button--primary,.el-button--primary.is-disabled, .el-button--primary.is-disabled:active,
    .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover,
    .el-button--primary.is-active, .el-button--primary:active{
        background-color:#0e4ddf !important;
        border-color:#0e4ddf !important;
    }
</style>